import { useState } from "react";

/**
 * 杂项状态 Hook - 整合剩余的独立状态
 */
const useMiscState = () => {
  const [homeworks, setHomeworks] = useState([]);
  const [wsClient, setWsClient] = useState(null);
  const [welcomeMessage, setWelcomeMessage] = useState(null);
  const [params, setParams] = useState({
    idea: "",
    role: "",
    task: "",
    context: "",
    format: "",
    tone: "",
  });

  // 重置杂项状态
  const resetMiscState = () => {
    setHomeworks([]);
    setWsClient(null);
    setWelcomeMessage(null);
    setParams({
      idea: "",
      role: "",
      task: "",
      context: "",
      format: "",
      tone: "",
    });
  };

  return {
    homeworks,
    setHomeworks,
    wsClient,
    setWsClient,
    welcomeMessage,
    setWelcomeMessage,
    params,
    setParams,
    resetMiscState,
  };
};

export default useMiscState;
